/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} memberWebAppQuizCheckSnapshotParams
* @property {GUID} challengeId - challengId, optional
* @property {string} origin - Quiz question
* @property {string} questionsJson - JSON with list of questions and answers + right answer indicator
* @property {string} screenName - <ScreenName.ModalOrDialogScreenNameOptional>
* @property {string} step - StepId
**/
/**
 * Name: Member.WebApp.Quiz.Check.Snapshot. Evid: 604.


 * challengeId - Type: guid. Desc: challengId, optional
 *
 * origin - Type: string. Desc: Quiz question
 *
 * questionsJson - Type: string. Desc: JSON with list of questions and answers + right answer indicator
 *
 * screenName - Type: string. Desc: <ScreenName.ModalOrDialogScreenNameOptional>
 *
 * step - Type: string. Desc: StepId
 * @param {memberWebAppQuizCheckSnapshotParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var memberWebAppQuizCheckSnapshot = function (params) {
    return { evid: 604, src: 114, endpoint: 'challenges-member-web', params: params };
};
/**
* @typedef {Object} memberWebAppScreenOpenParams
* @property {GUID} challengeId - challengId, optional
* @property {string} origin - BM \ Editor
* @property {string} screenName - <ScreenName.ModalOrDialogScreenNameOptional>
* @property {string} step - StepId, optional
* @property {string} tabName - optional, published / draft / discussion / etc.
**/
/**
 * Name: Member.WebApp.Screen.Open. Evid: 600.


 * challengeId - Type: guid. Desc: challengId, optional
 *
 * origin - Type: string. Desc: BM \ Editor
 *
 * screenName - Type: string. Desc: <ScreenName.ModalOrDialogScreenNameOptional>
 *
 * step - Type: string. Desc: StepId, optional
 *
 * tabName - Type: string. Desc: optional, published / draft / discussion / etc.
 * @param {memberWebAppScreenOpenParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var memberWebAppScreenOpen = function (params) {
    return { evid: 600, src: 114, endpoint: 'challenges-member-web', params: params };
};
/**
* @typedef {Object} memberWebWidgetShownParams
* @property {GUID} challengeId - challengId, optional
* @property {number} itemsCount - items count on a page in a widget
* @property {string} origin - Site
* @property {string} screenName - WelcomeScreen / ChallengesList/ ChallengeDetails / etc.
* @property {string} step - StepId, optional
* @property {number} timeSpent - milliseconds
**/
/**
 * Name: Member.Web.Widget.Shown. Evid: 620.
 * Event description: When widget has shown on a page (WEB).

 * challengeId - Type: guid. Desc: challengId, optional
 *
 * itemsCount - Type: numeric. Desc: items count on a page in a widget
 *
 * origin - Type: string. Desc: Site
 *
 * screenName - Type: string. Desc: WelcomeScreen / ChallengesList/ ChallengeDetails / etc.
 *
 * step - Type: string. Desc: StepId, optional
 *
 * timeSpent - Type: numeric. Desc: milliseconds
 * @param {memberWebWidgetShownParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var memberWebWidgetShown = function (params) {
    return { evid: 620, src: 114, endpoint: 'challenges-member-web', params: params };
};
/**
* @typedef {Object} memberWebAppButtonClickParams
* @property {string} buttonName - <the button name (code). lower case.>
* @property {GUID} challengeId - guid (optional)
* @property {boolean} isRequired - (optional, for feedback questions)
* @property {string} origin - BM / Editor / Site
* @property {string} screenName - <ScreenName.ModalOrDialogScreenNameOptional>
* @property {string} sectionId - section ID
* @property {string} step - string (optional)
* @property {string} tabName - optional, published / draft / discussion / etc.
* @property {string} userEntry - where click happened (i.e. sidebar, challenge list)
**/
/**
 * Name: Member.WebApp.Button.Click. Evid: 601.
 * Event description: Button click event
(must cover all buttons, Save/Done/Next/Back/New/Link/Share/etc.)
for member app.

 * buttonName - Type: string. Desc: <the button name (code). lower case.>
 *
 * challengeId - Type: guid. Desc: guid (optional)
 *
 * isRequired - Type: bool. Desc: (optional, for feedback questions)
 *
 * origin - Type: string. Desc: BM / Editor / Site
 *
 * screenName - Type: string. Desc: <ScreenName.ModalOrDialogScreenNameOptional>
 *
 * sectionId - Type: string. Desc: section ID
 *
 * step - Type: string. Desc: string (optional)
 *
 * tabName - Type: string. Desc: optional, published / draft / discussion / etc.
 *
 * userEntry - Type: string. Desc: where click happened (i.e. sidebar, challenge list)
 * @param {memberWebAppButtonClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var memberWebAppButtonClick = function (params) {
    return { evid: 601, src: 114, endpoint: 'challenges-member-web', params: params };
};
/**
* @typedef {Object} memberWebAppOnBeforeActionParams
* @property {GUID} actionId - <unique value per action, mandatory>
* @property {string} actionType - challenge_join / payment / join_with_payment / join_request_create / join_request_cancel / step_comment_save / feedback_send / feedback_save / notification_settings_set / step_complete / challenge_complete / challenge_left
* @property {GUID} challengeId - guid (current challengeId)
* @property {string} origin - BM / Editor
* @property {string} screenName - <ScreenName.ModalOrDialogScreenNameOptional>
* @property {string} step - string  (optional)
* @property {string} tabName - tab name - optional
**/
/**
 * Name: Member.WebApp.onBeforeAction. Evid: 603.
 * Event description: Before Action, client event
for member app.

 * actionId - Type: guid. Desc: <unique value per action, mandatory>
 *
 * actionType - Type: string. Desc: challenge_join / payment / join_with_payment / join_request_create / join_request_cancel / step_comment_save / feedback_send / feedback_save / notification_settings_set / step_complete / challenge_complete / challenge_left
 *
 * challengeId - Type: guid. Desc: guid (current challengeId)
 *
 * origin - Type: string. Desc: BM / Editor
 *
 * screenName - Type: string. Desc: <ScreenName.ModalOrDialogScreenNameOptional>
 *
 * step - Type: string. Desc: string  (optional)
 *
 * tabName - Type: string. Desc: tab name - optional
 * @param {memberWebAppOnBeforeActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var memberWebAppOnBeforeAction = function (params) {
    return { evid: 603, src: 114, endpoint: 'challenges-member-web', params: params };
};
/**
* @typedef {Object} memberWebOnAfterActionParams
* @property {GUID} actionId - action ID
* @property {string} actionType - action_type, must be the same as on onBeforeAction, onAction
* @property {string} screenName - <ScreenName>
* @property {DateTime} startDate_ - selected Challenges Start Date (for Flexible challenges)
**/
/**
 * Name: MemberWeb.onAfterAction. Evid: 610.
 * Event description: after action on client side.

 * actionId - Type: guid. Desc: action ID
 *
 * actionType - Type: string. Desc: action_type, must be the same as on onBeforeAction, onAction
 *
 * screenName - Type: string. Desc: <ScreenName>
 *
 * startDate_ - Type: datetime. Desc: selected Challenges Start Date (for Flexible challenges)
 * @param {memberWebOnAfterActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var memberWebOnAfterAction = function (params) {
    return { evid: 610, src: 114, endpoint: 'challenges-member-web', params: params };
};
//# sourceMappingURL=index.js.map